import React from 'react';
import { PageHeader } from '@/components/shared/ui';

interface BreadcrumbItem {
    label: string;
    link?: string;
}

interface CenteredPageLayoutProps {
    title: string;
    description?: string;
    /** @deprecated Breadcrumbs 컴포넌트 삭제로 미사용. 호환성 위해 수용만 함 */
    breadcrumbs?: BreadcrumbItem[];
    children: React.ReactNode;
    maxWidth?: string;
}

/**
 * 주문관리 스타일의 센터 정렬 페이지 레이아웃
 * - 센터 정렬된 타이틀 (PageHeader 사용)
 * - max-w-5xl 중앙 정렬 컨테이너
 */
export default function CenteredPageLayout({
    title,
    description,
    breadcrumbs: _breadcrumbs,
    children,
    maxWidth = 'max-w-5xl'
}: CenteredPageLayoutProps): React.ReactElement {
    return (
        <div className="min-h-screen">
            <div className={`${maxWidth} mx-auto px-4 py-4`}>
                <PageHeader
                    title={title}
                    description={description}
                    align="center"
                />
                {children}
            </div>
        </div>
    );
}
